import { Room } from "@uno/protocol";
import { create } from "zustand";
import useStoreRoomSession from "./useStoreRoomSession";

type StateStoreRoom = {
    room: Room | null,
    clockOffset: number,
}

type StoreRoomActions = {
    setRoom: (room: Room | null, receivedAt?: number) => void,
    reset: () => void,
}

const useStoreRoom = create<StateStoreRoom & StoreRoomActions>((set) => ({
    room: null,
    clockOffset: 0,

    setRoom: (room, receivedAt) => set((state) => ({
        room,
        clockOffset: room?.serverTime && receivedAt ? room.serverTime - receivedAt : state.clockOffset,
    })),
    reset: () => set(() => ({ room: null, clockOffset: 0 })),
}));

useStoreRoomSession.subscribe(
    (state) => state.roomId,
    () => {
        useStoreRoom.getState().reset();
    }
);

export default useStoreRoom;
